import {Button, Tabs} from 'antd'
import {course_class_getAttendances_Api,} from 'apis'
import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsPersonCircle, BsThreeDots} from 'react-icons/bs'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {DateNameSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CouseClassAttendanceFilter from 'views/Workspace/Course/components/filters/CouseClassAttendanceFilter'
import {renderCourseClassAttendance} from 'views/Workspace/Course/functions/renderCourseClassAttendance'
import {bindQueryParam} from '../../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes} from '../../../Templates/items/ListHeader'
import CourseClassContext from '../../CourseClassContext'
import {AiOutlineAudit} from "react-icons/ai";
import {renderIf, renderIfElse} from "../../../../Shared";
import EntityList from "../../../EntityList";
import EmptyHolder from "../../../../../components/EmptyHolder";
import {LoginContext} from "../../../../../components/LoginContext";
import {course_getAttendanceByStudentReportByAuth_Api} from "../../../../../apis";
import classNames from "classnames";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {GiIronCross} from "react-icons/gi";
import {GoDotFill} from "react-icons/go";
import {useRouteSearchParam} from "../../../../../envs/_current/history";
import {FaIdCard} from "react-icons/fa";
import {PiUserListFill} from "react-icons/pi";
import {useCourseAttendances} from "../../functions/useCourseAttendances";
import {AttendanceActionTypes} from "../../index";


const MyBoard = ({course_class_id}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const refreshKey = course_class_id

    const renderItem = useCallback((item, index) => {

        const {subject_title, number_of_sessions, number_of_sessions_updated, total_sessions} = item ?? {}

        const percent_session = Number((total_sessions / number_of_sessions) * 100).toFixed(1)
        let color

        if (percent_session === '0.0') {
            color = 'text-color-300'
        } else if (0.0 < percent_session < 50.0) {
            color = 'text-red-500'
        } else if (50.0 <= percent_session && percent_session < 74.9) {
            color = 'text-blue-500'
        } else if (percent_session >= 75.0) {
            color = 'text-green-500'
        }

        return (
            <div key={index} className="flex flex-col">
                <div className="flex items-center gap-2 text-sm">
                    <GiIronCross size={11} className="text-primary-300"/>
                    <span className="font-bold text-color-000">
              {subject_title}
            </span>
                </div>
                <div style={{marginLeft: 18}} className="flex items-center justify-between gap-3 leading-snug">
                    <div className="flex items-center gap-1 text-xs italic">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="text-color-500">{`${t('number of attended lessons')} : `}</span>
                        <span className="font-bold text-color-100">{`${total_sessions} ${t('sessions')}`}</span>
                    </div>
                    <span className={classNames("font-bold text-xs italic", color)}>
              {`${percent_session}%`}
            </span>
                </div>
            </div>
        )
    }, [])

    const renderWrap = useCallback((child, __, count) => {
        return (
            <div className="flex flex-col gap-3 my-2">
                <HeaderWithIconLine
                    icon={<BsPersonCircle size={20} className="text-blue-300"/>}
                    title="my attendances"
                    className="text-blue-600 leading-snug"
                    lineColor="border-blue-300"
                    center={true}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
                    {child}
                </div>
            </div>
        )
    }, [])

    return renderIf(
        login,
        <EntityList
            key={refreshKey}
            renderEmpty={() => <EmptyHolder title={null} className="col-span-1 md:col-span-2"/>}
            renderItem={renderItem}
            renderWrap={renderWrap}
            refreshKey={refreshKey}
            RenderEntity={React.Fragment}
            query={bindQueryParam({id: course_class_id})}
            apiInfo={course_getAttendanceByStudentReportByAuth_Api}
        />
    )
}

const CourseClassAttendanceTab = ({
                                      filter_actions = {
                                          sortBy: 'sort-by',
                                          keyword: 'keyword',
                                          course_id: 'course_id',
                                          subject_id: 'subject-id',
                                      },
                                  }) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('0')

    const {item} = useContext(CourseClassContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const subject_id = useRouteSearchParam(filter_actions.subject_id)

    const can_edit = !!item?.edit

    const course_class_id = getId(item)

    const owner_id = getId(item?.course)

    const owner_type = getType(item?.course)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
    } = useCourseAttendances({course_class: item})

    const refreshKey = useMemo(
        () => [refresh_token, course_class_id].join(''),
        [refresh_token, course_class_id]
    )

    const renderContextMenu = useCallback(
        (item) =>
            can_edit
                ? createContextMenu(
                [
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendances',
                        key: AttendanceActionTypes.DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: AttendanceActionTypes.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: AttendanceActionTypes.DELETE,
                    },
                ].filter((e) => item), (key) => {
                    handleAction(key, item)
                },
                {
                    icon: (
                        <div
                            style={{width: 22, height: 22, borderRadius: 999}}
                            className="flex flex-center background hover:background-200 text-color-500 hover:text-color-100 cursor-pointer">
                            <BsThreeDots size={12}/>
                        </div>
                    ),
                }
                )
                : undefined,
        [can_edit]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                subject_id,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            PaginationMeta: NullAsDefault,
            RenderEntity: React.Fragment,
            apiInfo: course_class_getAttendances_Api,
            query: bindQueryParam({id: course_class_id}),
            renderItem: renderCourseClassAttendance({
                renderContextMenu,
                handleAction,
            }),
        },
        renderSearchBar: NullAsDefault,
        SortByWidget: DateNameSortBy,
        query_params: filter_actions,
        sortHeader: t('list of lesson'),
        withKey: createPagerKey(refreshKey),
        AdvancedFilter: CouseClassAttendanceFilter,
    })

    return (
        <div className="flex flex-col">
            {renderIfElse(
                can_edit,
                <Tabs
                    className="custom-tabs-student"
                    type="card"
                    centered={false}
                    tabBarGutter={8}
                    defaultActiveKey="0"
                    onChange={setCurrent}
                    items={[
                        {
                            key: "0",
                            label: (
                                <span className="flex items-center gap-2">
                                    <PiUserListFill size={14}/>
                                    <span className="font-medium leading-tight">
                                        {t("attendance of students")}
                                    </span>
                                </span>
                            ),
                            children: (
                                <div className="w-full flex flex-col flex-1 gap-6">
                                    <div className="flex flex-col gap-1">
                                        <ListHeaderLineAndDes
                                            line={false}
                                            title="attendance of students"
                                            description="create attendance description"
                                            extra={
                                                <div className="flex flex-1 justify-end gap-2 md:gap-3">
                                                    <Button
                                                        style={{
                                                            padding: isSm ? "0 12px" : "0 18px",
                                                        }}
                                                        className="button-rounded-md no-border flex flex-center bg-primary-50 hover:bg-primary-100 font-medium text-xs md:text-sm text-primary"
                                                        onClick={() => {
                                                            handleAction(AttendanceActionTypes.VIEW_BY_SUBJECT_FILTER);
                                                        }}>
                                                        {t("results")}
                                                    </Button>
                                                    <Button
                                                        style={{
                                                            padding: isSm ? "0 12px" : "0 18px",
                                                        }}
                                                        type="primary"
                                                        className="button-rounded-md no-border flex flex-center font-medium text-xs md:text-sm"
                                                        onClick={() => {
                                                            handleAction(AttendanceActionTypes.CREATE);
                                                        }}>
                                                        {t("create")}
                                                    </Button>
                                                </div>
                                            }
                                        />
                                        <div className="flex flex-col gap-3">{pager_widget}</div>
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: "1",
                            label: (
                                <div className="flex items-center gap-2">
                                    <FaIdCard size={14}/>
                                    <span className="font-medium leading-tight">
                                        {t("my attendances")}
                                    </span>
                                </div>
                            ),
                            children: (
                                <div className="w-full flex flex-col flex-1 gap-6">
                                    <MyBoard course_class_id={course_class_id}/>
                                </div>
                            ),
                        },
                    ]}
                />,
                <div className="w-full flex flex-col flex-1 gap-6">
                    <MyBoard course_class_id={course_class_id}/>
                </div>
            )}

            {modal}
        </div>
    )
}

export default CourseClassAttendanceTab
